import { getSpacingOptions } from './getSpacingOptions.js';
import { getColorOptions } from './getColorOptions.js';
import { getTypographyOptions } from './getTypographyOptions.js';
import { getLayoutOptions } from './getLayoutOptions.js';
const mappers = [
    { key: 'spacing', fn: getSpacingOptions },
    { key: 'color', fn: getColorOptions },
    { key: 'typography', fn: getTypographyOptions },
    { key: 'layout', fn: getLayoutOptions },
];
export function getSettingsOptions(settings) {
    const result = Object.entries(settings).reduce((acc, [key, value]) => {
        for (let i = 0; i < mappers.length; i += 1) {
            if (mappers[i].key === key) {
                const options = mappers[i].fn(value);
                return Object.assign(Object.assign({}, acc), options);
            }
        }
        return acc;
    }, {});
    return result;
}
